// import "./index.scss";
import React from 'react';
import { Input, Button, Icon, Row, Col, Form, Select, message } from "antd";
import { Link } from 'react-router-dom';
import { _APP, getSmsCode, regist } from './../../apis/apis';
class Register extends React.Component {
    // componentDidMount(){
    //     console.log("Register PAGE OPEN")
    // }
    // componentWillUnmount(){
    //     console.log("Register PAGE CLOSE")
    // }
    state = {
        name: "",
        phone: "",
        idenCode: "",
        //验证码计时
        defaultTimer: 60,
        timer: 0
    }
    setPhone = (e) => {
        this.setState({
            phone: e.target.value
        })
    }
    getIdenCode = (e, phone) => {
        if (this.state.timer != 0) {
            e.preventDefault();
            return;
        } else {
            if (!phone) {
                this.setState({
                    msg: "请输入手机号"
                });
                return;
            }
            this.setState({
                defaultTimer: 60
            }, () => {
                getSmsCode(phone).then((response) => {
                    let intervalid = window.setInterval(() => {
                        this.setState({
                            timer: this.state.defaultTimer--
                        }, () => {
                            if (this.state.timer === 0) {
                                window.clearInterval(intervalid);
                            }
                        })
                    }, 1000);
                }).catch((error) => {
                    let data = error.response && error.response.data ? error.response.data : { msg: "操作过于频繁，请稍后再试！" };
                    message.error(data.msg);
                });
            })
        }
    }
    compareToFirstPassword = (rule, value, callback) => {
        const form = this.props.form;
        // console.log('compareToFirstPassword');
        // console.log(value);
        if (value && value !== form.getFieldValue('password')) {
            callback('两次输入的密码不相符!');
        } else {
            callback();
        }
    }

    validateToNextPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && this.state.confirmDirty) {
            form.validateFields(['confirm'], { force: true });
        }
        callback();
    }
    //提交注册
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({
                    loading: true
                });
                //提交注册
                regist(values.name, values.password, values.phone, values.captcha).then(response => {
                    let data = response.data;
                    if ("5" === data.code) {
                        this.setState({
                            msg: "用户名重复"
                        });
                    } else if ("4" === data.code) {
                        this.setState({
                            msg: "手机号已被占用"
                        });
                    } else if ("1" === data.code) {
                        this.setState({
                            msg: "验证码错误"
                        });
                    } else if ("2" === data.code) {
                        let i = 5;
                        let intervalId = setInterval(() => {
                            if (i !== 0) {
                                this.setState({
                                    msg: `注册成功，即将跳转登录${i}s`
                                });
                            } else {
                                this.props.history.push({ pathname: '/login' });
                                window.clearInterval(intervalId);
                            }
                            i--;
                        }, 1000);
                    } else if ("3" === data.code) {
                        this.setState({
                            msg: "验证码过期"
                        });
                    }
                    this.setState({
                        loading: false
                    });
                }).catch((error) => {
                    this.setState({
                        loading: false
                    });
                });
            }
        });
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const prefixSelector = getFieldDecorator('prefix', {
            initialValue: '86',
        })(
            <Select style={{ width: 70 }}>
                <Select.Option value="86">+86</Select.Option>
            </Select >
        );
        return (
            <Form id="register" onSubmit={this.handleSubmit}>
                <Form.Item  {...formItemLayout} label="用户名">
                    {getFieldDecorator('name', {
                        rules: [{ required: true, message: '请输入用户名' },
                        {
                            pattern: /^(?!_)[a-zA-Z0-9_\u4e00-\u9fa5]{6,12}$/, message: "用户名为6-12个字符,只能为汉字、数字、字母、下划线"
                        }],
                    })(
                        <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="用户名" autoComplete="username"/>
                    )}
                </Form.Item>
                <Form.Item  {...formItemLayout} label="密码">
                    {getFieldDecorator('password', {
                        rules: [{
                            required: true, message: '请输入密码!',
                        },
                        //{ pattern: /^[A-Za-z0-9]{6,16}$/, message: "密码只能包含数字、字母、下划线" },
                        {
                            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,}$/,
                            message: "密码最少6位，包括至少1个大写字母，1个小写字母，1个数字"
                        },
                        // {
                        //     validator: this.validateToNextPassword,
                        // }
                        ]
                    })(
                        <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="密码" autoComplete="new-password" />
                    )}
                </Form.Item>
                <Form.Item  {...formItemLayout}
                    label="确认密码">
                    {getFieldDecorator('confirm', {
                        rules: [{
                            required: true, message: '再次輸入密码',
                        }, {
                            validator: this.compareToFirstPassword,
                        }],
                    })(
                        <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="再次輸入密码" autoComplete="new-password"/>
                    )}
                </Form.Item>
                <Form.Item
                    {...formItemLayout}
                    label="手机号"
                >
                    {getFieldDecorator('phone', {
                        rules: [{ required: true, message: '请输入手机号!' }, {
                            pattern: /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/, message: "请输入正确的手机号"
                        }],
                    })(
                        <Input addonBefore={prefixSelector} style={{ width: '100%' }} onChange={this.setPhone} />
                    )}
                </Form.Item>
                <Form.Item
                    {...formItemLayout}
                    label="验证码"
                >
                    <Row gutter={8}>
                        <Col span={12}>
                            {getFieldDecorator('captcha', {
                                rules: [{ required: true, message: '请输入验证码' }],
                            })(
                                <Input />
                            )}
                        </Col>
                        <Col span={12}>
                            <Button onClick={(e => {
                                this.getIdenCode(e, this.state.phone)
                            })}>{this.state.timer === 0 ? "获取验证码" : this.state.timer + "s后再次获取"}</Button>
                        </Col>
                    </Row>
                </Form.Item>
                <Row><Link to="/login" >登录</Link><Link to="/forget" style={{ float: "right" }}>忘记密码</Link></Row>
                <Form.Item>
                    <Button type="primary" size="large" style={{ marginTop: "10px" }} htmlType="submit" block>注册{this.state.loading ? <Icon type="loading" /> : null}</Button>
                </Form.Item>
                <Row><div className="msg">{this.state.msg}</div></Row>
            </Form>
        );
    }
}

export default Form.create({ name: 'register' })(Register);